(function () {
  if (window.__jbSections) return;
  window.__jbSections = true;

  class JbSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.slides = Array.from(this.querySelectorAll('[data-slide]'));
      this.dotsWrap = this.querySelector('[data-dots]');
      if (!this.track || this.slides.length < 2) return;
      this.index = 0;
      this.buildDots();
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.index - 1));
      if (next) next.addEventListener('click', () => this.go(this.index + 1));
      this.track.addEventListener('scroll', () => this.onScroll(), { passive: true });
      if (this.dataset.autoplay === 'true') this.startAutoplay();
      ['mouseenter', 'focusin', 'touchstart'].forEach((e) => this.addEventListener(e, () => this.stopAutoplay(), { passive: true }));
      ['mouseleave', 'focusout'].forEach((e) => this.addEventListener(e, () => { if (this.dataset.autoplay === 'true') this.startAutoplay(); }));
    }
    disconnectedCallback() { this.stopAutoplay(); }
    buildDots() {
      if (!this.dotsWrap) return;
      this.dots = this.slides.map((_, i) => {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'jb-slider__dot';
        b.setAttribute('aria-label', 'Slide ' + (i + 1));
        b.addEventListener('click', () => this.go(i));
        this.dotsWrap.appendChild(b);
        return b;
      });
      this.updateDots();
    }
    updateDots() {
      if (!this.dots) return;
      this.dots.forEach((d, i) => d.setAttribute('aria-current', i === this.index ? 'true' : 'false'));
    }
    onScroll() {
      var w = this.track.clientWidth || 1;
      this.index = Math.round(this.track.scrollLeft / w);
      this.updateDots();
    }
    go(i) {
      var n = this.slides.length;
      this.index = (i + n) % n;
      this.track.scrollTo({ left: this.index * this.track.clientWidth, behavior: 'smooth' });
      this.updateDots();
    }
    startAutoplay() {
      this.stopAutoplay();
      var delay = parseInt(this.dataset.delay, 10) || 6000;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.timer = setInterval(() => this.go(this.index + 1), delay);
    }
    stopAutoplay() { clearInterval(this.timer); }
  }

  class JbTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.panels = Array.from(this.querySelectorAll('[data-panel]'));
      this.tabs.forEach((tab) => {
        tab.addEventListener('click', () => this.select(tab.dataset.tab));
        tab.addEventListener('keydown', (e) => {
          var i = this.tabs.indexOf(tab);
          if (e.key === 'ArrowRight') this.focusTab(i + 1);
          if (e.key === 'ArrowLeft') this.focusTab(i - 1);
        });
      });
    }
    focusTab(i) {
      var tab = this.tabs[(i + this.tabs.length) % this.tabs.length];
      tab.focus();
      this.select(tab.dataset.tab);
    }
    select(id) {
      this.tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.tab === id ? 'true' : 'false'));
      this.panels.forEach((p) => { p.hidden = p.dataset.panel !== id; });
    }
  }

  class JbLookbook extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', (e) => {
        var dot = e.target.closest('.jb-hotspot__dot');
        if (!dot) return;
        var open = dot.getAttribute('aria-expanded') === 'true';
        this.closeAll();
        if (!open) {
          dot.setAttribute('aria-expanded', 'true');
          dot.nextElementSibling.hidden = false;
        }
      });
      document.addEventListener('click', (e) => { if (!this.contains(e.target)) this.closeAll(); });
      this.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.closeAll(); });
    }
    closeAll() {
      this.querySelectorAll('.jb-hotspot__dot').forEach((d) => {
        d.setAttribute('aria-expanded', 'false');
        d.nextElementSibling.hidden = true;
      });
    }
  }

  class JbCountdown extends HTMLElement {
    connectedCallback() {
      this.end = new Date(this.dataset.end).getTime();
      if (isNaN(this.end)) { this.hidden = true; return; }
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      var left = Math.max(0, this.end - Date.now());
      if (left === 0) {
        clearInterval(this.timer);
        var target = this.dataset.hideTarget && this.closest(this.dataset.hideTarget);
        if (target) { target.hidden = true; return; }
        if (this.dataset.expired) this.textContent = this.dataset.expired;
        else this.hidden = true;
        return;
      }
      var pad = (n) => String(n).padStart(2, '0');
      var set = (sel, v) => { var el = this.querySelector(sel); if (el) el.textContent = pad(v); };
      set('[data-days]', Math.floor(left / 86400000));
      set('[data-hours]', Math.floor(left / 3600000) % 24);
      set('[data-minutes]', Math.floor(left / 60000) % 60);
      set('[data-seconds]', Math.floor(left / 1000) % 60);
    }
  }

  class JbScroller extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      var step = () => Math.max(200, this.track.clientWidth * 0.8);
      var prev = this.querySelector('[data-prev]');
      var next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this.track.scrollBy({ left: -step(), behavior: 'smooth' }));
      if (next) next.addEventListener('click', () => this.track.scrollBy({ left: step(), behavior: 'smooth' }));
      this.bar = this.querySelector('[data-progress]');
      this.track.addEventListener('scroll', () => this.update(), { passive: true });
      this.update();
    }
    update() {
      if (!this.bar) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      var visible = this.track.scrollWidth ? this.track.clientWidth / this.track.scrollWidth : 1;
      var pos = max > 0 ? this.track.scrollLeft / max : 0;
      this.bar.style.width = Math.round(visible * 100) + '%';
      this.bar.style.marginLeft = Math.round((1 - visible) * pos * 100) + '%';
    }
  }

  class JbFeatureTabs extends HTMLElement {
    connectedCallback() {
      this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.show(i)));
    }
    show(index) {
      var panels = this.querySelectorAll('.jb-ftabs__panel');
      var images = this.querySelectorAll('.jb-ftabs__image');
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index ? 'true' : 'false');
        if (panels[i]) panels[i].hidden = i !== index;
        if (images[i]) images[i].hidden = i !== index;
      });
    }
  }

  [['jb-slider', JbSlider], ['jb-tabs', JbTabs], ['jb-lookbook', JbLookbook], ['jb-countdown', JbCountdown], ['jb-scroller', JbScroller], ['jb-feature-tabs', JbFeatureTabs]].forEach(function (d) {
    if (!customElements.get(d[0])) customElements.define(d[0], d[1]);
  });
})();
